import { useExperiment } from "hooks/useExperiment";
import { ReactElement } from "react";
import LassieLoader from "ui-kit/LassieLoader";
import { FlexRow } from "ui-kit/Layout/Flex";

type ExperimentProps = {
  featureName: string;
  variations: Record<string, ReactElement>;
};

export function Experiment({ featureName, variations }: ExperimentProps) {
  const { initiated, variant } = useExperiment(
    featureName,
    Object.keys(variations)[0]
  );

  if (!initiated) {
    return (
      <FlexRow alignItems="center" justifyContent="center">
        <LassieLoader />
      </FlexRow>
    );
  }

  if (!variant) {
    return variations[0];
  }

  const currentVariantElement = variations[variant];

  if (!currentVariantElement) {
    throw Error(
      `No variant '${variant}' defined for experiment: ${featureName}`
    );
  }

  return currentVariantElement;
}
